var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSizeBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1198.97 1198.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-dasharray: 0 0 72.84 121.39;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke: #009fe3;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 48px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-dasharray: 0 0 72.88 121.46;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "81.49 24 81.49 1117.48 1174.97 1117.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "24 182 82.02 24 138.99 180.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1016.97 1059.98 1174.97 1118 1018.01 1174.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 204.66,
    y1: 24,
    x2: 240.66,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 362.05,
    y1: 24,
    x2: 1078.27,
    y2: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1138.97 24 1174.97 24 1174.97 60"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1174.97,
    y1: 181.46,
    x2: 1174.97,
    y2: 898.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1174.97,
    y1: 958.84,
    x2: 1174.97,
    y2: 994.84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 224.52,
    y1: 1002.68,
    x2: 1031.94,
    y2: 195.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 224.52,
    y1: 800.83,
    x2: 830.09,
    y2: 195.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 224.52,
    y1: 598.97,
    x2: 628.23,
    y2: 195.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 224.52,
    y1: 397.11,
    x2: 426.38,
    y2: 195.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 426.38,
    y1: 1002.68,
    x2: 1031.94,
    y2: 397.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 628.23,
    y1: 1002.68,
    x2: 1031.94,
    y2: 598.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 830.09,
    y1: 1002.68,
    x2: 1031.94,
    y2: 800.83
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeBlue);
export default __webpack_public_path__ + "static/media/size_blue.62cf1363a4e7758692c98f818ec8266a.svg";
export { ForwardRef as ReactComponent };